import { render, staticRenderFns } from "./personalDetails.vue?vue&type=template&id=7100824f&scoped=true"
import script from "./personalDetails.vue?vue&type=script&lang=js"
export * from "./personalDetails.vue?vue&type=script&lang=js"
import style0 from "./personalDetails.vue?vue&type=style&index=0&id=7100824f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7100824f",
  null
  
)

export default component.exports